export class ChapterManager {

	/**
	 * Current chapter being displayed on screen
	 */
	private currentChapterIndx: number;
	public get currentChapter(): Chapter {
		return this.chapters[this.currentChapterIndx];
	}

	private chapters: Chapter[] = [];
	public isLoaded: boolean;

	public setChapter(chapterId: string) {
		this.currentChapterIndx = -1;
		for(var indx = 0; indx < this.chapters.length; indx++) {
			if(this.chapters[indx].title === chapterId) {
				this.currentChapterIndx = indx;
				break;
			}
		}
		if(this.currentChapterIndx === -1) {
			throw Error('Could not find chapter with id ' + chapterId);
		}
	}

	public loadSrt(path: string): void {
		var context = this;
		$.get(path).then((result) => {
			context._strToObject(result).then((r: Chapter[]) => {
				this.chapters = r;
				this.currentChapterIndx = 0;
				context.isLoaded = true;
			});
		});
	}
	private _strToObject(str: string): any {
		return new Promise((resolve, reject) => {
			var result: Chapter[] = [];
			var lines: string[] = str.split('\n');
			
			enum lineType {
				id = 0,
				time = 1,
				title = 2
			}

			var currentLineType = lineType.id;
			var currChapter: Chapter = {};

			for(var lineIndx = 0; lineIndx < lines.length; lineIndx++) {
				var currentLine = lines[lineIndx].replace('\\r', '').trim();

				if(currentLine === '') {
					continue;
				}

				switch(currentLineType) {
					case lineType.id:
						currChapter.id = this.parseId(currentLine);
						break;
					case lineType.time:
						var time = this.parseTime(currentLine);
						currChapter.start = time.start;
						currChapter.end = time.end;
						break;
					case lineType.title:
						currChapter.title = this.parseTitle(currentLine);
						break;
				}

				currentLineType++;

				if(currentLineType > lineType.title) {
					result.push(currChapter);
					currChapter = {};
					currentLineType = lineType.id;
				}
			}

			resolve(result);
		});
	}

	private parseId(line: string): string {
		return line;
	}

	private parseTime(line: string): {start: number, end: number} {
		var onParseTime = (timeStr: string) => {
			var splitTime = timeStr.split(':');
			var secondAndMillisecondSplit = splitTime[2].split(',');

			var hours = parseInt(splitTime[0]);
			var minutes = parseInt(splitTime[1]);
			var seconds = parseInt(secondAndMillisecondSplit[0]);
			var milliseconds = parseInt(secondAndMillisecondSplit[1]);

			var totalTimeInSeconds = 0;

			totalTimeInSeconds += (hours * 3600);
			totalTimeInSeconds += (minutes * 60);
			totalTimeInSeconds += seconds;
			totalTimeInSeconds += milliseconds / 1000;

			return totalTimeInSeconds;
		};

		var startEndTimeSplit = line.split('-->');

		return {
			start: onParseTime(startEndTimeSplit[0].trim()),
			end: onParseTime(startEndTimeSplit[1].trim())
		}
	}

	private parseTitle(line: string): string {
		return line;
	}
}

export interface Chapter {
	id?: string;
	start?: number;
	end?: number;
	title?: string;
}